
export const VERSION = '5.4.24'; // Update this manually on each release

